import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Container from 'app/common/narrow-container';

import { login } from 'app/redux/modules/auth';

import Paper from '@mui/material/Paper';

import Button from 'app/common/button';
import Input from 'app/common/form/input';
import Alert from 'app/common/alert';

import i18n from 'app/common/i18n';

@connect(({ auth: { user } }) => ({ user }), { login })
@i18n
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: null,
      password: null,
      error: null
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      this.props.navigate('/dashboard');
    }
  }

  onChange = (ev) => {
    this.setState({ [ev.target.name]: ev.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { password, username } = this.state;

    if (!password || !username) {
      this.setState({
        error: this.props.i18n(
          'You have left out %s?',
          !password ? 'adgangskode' : 'email'
        )
      });
      return;
    }

    this.setState({ error: null });
    this.props.login({ username, password }).then((action) => {
      if (action.error) {
        const { error: { response } = {} } = action || {};

        this.setState({
          error:
            (response && this.props.i18n(response.message)) ||
            this.props.i18n(
              'Oops! Something went wrong. Please try again or contact customer support'
            )
        });
      }

      return action;
    });
  };

  render() {
    const { error } = this.state;

    return (
      <Container header={this.props.i18n('Sign In')}>
        <Paper
          component="form"
          className="login"
          onSubmit={this.handleSubmit}
          style={{ marginBottom: '1em', padding: '1em' }}
        >
          <Input
            fullWidth
            name="username"
            onChange={this.onChange}
            required
            type="email"
            label={this.props.i18n('Email')}
          />
          <Input
            fullWidth
            name="password"
            onChange={this.onChange}
            required
            type="password"
            label={this.props.i18n('Password')}
          />

          <br />
          {error ? <Alert type="danger" text={error} /> : null}

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '1em'
            }}
          >
            <div>
              <Button
                type="submit"
                primary
                label={this.props.i18n('Sign In')}
              />
              <Button
                to="/signup"
                primary
                flat
                label={`${this.props.i18n('New landlord')}?`}
                style={{ marginLeft: 8 }}
              />
            </div>
            <div>
              <Button
                to="/forgot-password"
                primary
                flat
                label={`${this.props.i18n('Glemt adgangskode')}?`}
              />
            </div>
          </div>
        </Paper>
      </Container>
    );
  }
}

function LoginWithNavigate(props) {
  const navigate = useNavigate();
  return <Login {...props} navigate={navigate} />;
}

export default LoginWithNavigate;